import { getEventTracker } from '@libs/eventTracking'
import {
  getNextPagePropertyFor,
  getCurrentPagePropertyFor,
} from '@libs/eventTracking/eventPropertyUtils'
import { WebEventNames } from './common'

/**
 * [Link to spec](https://github.com/popdaily/popdaily.tracking/blob/develop/tracking_events/events/web-header/web-header.enter-tw-popdaily.md)
 */
export function trackHeaderEnterTwPopdailyEvent() {
  getEventTracker().track({
    name: WebEventNames.WEB_HEADER_ENTER_TW_POPDAILY,
    properties: {
      currentPage: getCurrentPagePropertyFor(''),
      toPage: getNextPagePropertyFor({
        pageName: 'web-explore',
        pageUrl: window.location.origin,
      }),
    },
  })
}
